export default {"src":"/_next/static/media/find_in_page.8a629330.svg","height":32,"width":26,"blurWidth":0,"blurHeight":0};